<script lang="ts">
	//Stores
	import { sidePanelState, sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { devices } from 'src/stores/lists/devices';
import { rooms } from 'src/stores/lists/rooms';
	//Design System Components
	import { SidepanelLayout, SidepanelTabs } from '@Shelly/shelly-design-system';
	//Helpers
	import { checkIsComponent } from 'src/components/Sidepanel/sidepanel-helpers';
	//Components
	import Main from './Tabs/Main.svelte';
	import Statistics from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/Statistics.svelte';
	import ActivityLog from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/ActivityLog.svelte';
	import Notifications from './Tabs/Notifications.svelte';

	// Types
	import type { SidepanelTabsPropsTypesExtended } from 'src/components/Sidepanel/sidepanel-tabs-helpers';

	import SidePanelSettingsModalProvider from 'src/components/Sidepanel/SidePanelSettingsModal/SidePanelSettingsModalProvider.svelte';
	import { getDeviceChartsConfig } from 'src/helpers/statistics/config/device_chart_config';

	let tabIndex: number = 0;

	$: id = $sidePanelStateCombined?.id;
	$: device = $devices[id];
	$: deviceName = device?.name || 'SNSN-0024X';
	$: deviceRoom = $rooms?.[device?.room_id]?.name;
	$: hasStatisticsContent = device ? getDeviceChartsConfig(device).length > 0 : false;

	$: tabs = [
		{
			icon: 'fat fa-sliders-simple',
			component: Main,
		},
		...(hasStatisticsContent
			? [
					{
						icon: 'fat fa-chart-line',
						component: Statistics,
					},
				]
			: []),
		{
			icon: 'fat fa-notebook',
			component: ActivityLog,
		},
		{
			icon: 'fat fa-bell',
			component: Notifications,
		},
	].map((tab, index) => ({
		...tab,
		isActive: tabIndex === index,
		disabled: false,
	})) as SidepanelTabsPropsTypesExtended['tabs'];

	// Settings modal
	let showSettingsModal = false;

	$: if ($sidePanelState.showSettingsModal === true && !showSettingsModal) {
		showSettingsModal = true;
	}

	const onTabClick = (e: CustomEvent) => {
		const selectedTabData = e.detail;
		tabIndex = selectedTabData.index;
	};

	const resetActiveTab = () => {
		tabIndex = 0;
	};

	const handleSettings = () => {
		showSettingsModal = true;
	};

	$: if (!$sidePanelState.open) resetActiveTab();
</script>

<SidepanelLayout title={deviceName} subtitle={deviceRoom} onSettings={handleSettings}>
	<svelte:component this={checkIsComponent(tabs?.[tabIndex].component)} {device} />
	<SidepanelTabs slot="tabs" {tabs} on:click={onTabClick} />
</SidepanelLayout>

{#if showSettingsModal}
	<SidePanelSettingsModalProvider bind:showSettingsModal {device} />
{/if}
